import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const ModalLayout = styled(FlexColumn, {
  gap: '1.5rem',
  padding: '1rem 0 1.5rem 0',
})

export const Title = styled('h2', ({ $theme }) => ({
  fontSize: '1.0625rem',
  fontWeight: '600',
  color: $theme.colors.textBody,
  marginBottom: '0.25rem',
}))

export const Subtitle = styled('p', ({ $theme }) => ({
  fontSize: '0.875rem',
  color: $theme.colors.textSecondaryAlt,
  lineHeight: '1.4',
  marginTop: 0,
  marginBottom: '0.75rem',
}))

export const CheckboxGroup = styled(FlexColumn, {
  gap: '0.75rem',
})
